import { render } from "./SelectRadio.vue?vue&type=template&id=28ac97bf&scoped=true"
import script from "./SelectRadio.vue?vue&type=script&lang=js"
export * from "./SelectRadio.vue?vue&type=script&lang=js"

import "./SelectRadio.vue?vue&type=style&index=0&id=28ac97bf&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-28ac97bf"

export default script